

















































import { ROOT_NOTIFICATION } from "@/store/modules/root/constants";
import Vue from "vue";
import { mapMutations } from "vuex";

export default Vue.extend({
  name: "AiJobDescriptionModal",
  data() {
    return {
      dialog: true
    };
  },
  props: {
    job_description: {
      type: String,
      required: true
    },
    job_title: {
      type: String,
      required: true
    }
  },
  methods: {
    ...mapMutations({
      root_notification: ROOT_NOTIFICATION
    }),
    async regenerate_job() {
      this.root_notification(
        "Please enter the prompt again to generate a new Job."
      );
      await this.$router.push({ name: "ai-generated-job-posting" });
    }
  }
});
